var axios = require('axios');

module.exports = {
    sendEmail: function (data) {
        return axios.post('/api/sendEmail', data)
            .then(function (response) {
                return response;
            });
    }
};


// WEBPACK FOOTER //
// ./src/utils/Api.js